module.exports = __webpack_public_path__ + "static/media/cg.f2b5aada.svg";